import { Breadcrumb } from 'components/breadcrumb'
import { PecSwitch, PrivateRoute } from 'components/route'
import { useRouteMatch } from 'react-router'
import Permissions from 'types/Permissions'

import { UnificacaoBaseCadastrosDuplicadosView } from './UnificacaoBaseCadastrosDuplicadosView'

export default function UnificacaoBaseCadastrosDuplicadosRootView() {
  const match = useRouteMatch()
  return (
    <>
      <Breadcrumb title='Unificação de bases - Cadastros duplicados' />
      <PecSwitch>
        <PrivateRoute
          exact
          path={`${match.url}`}
          component={UnificacaoBaseCadastrosDuplicadosView}
          permission={Permissions.gestaoDeCadastros.unificacaoDeBases}
        />
      </PecSwitch>
    </>
  )
}
